var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('confirm-dialog',{attrs:{"title":'クイックアクセスから削除',"confirm-label":"削除する","message":'このアイテムをクイックアクセスから削除します'},on:{"confirm":_vm.deleteItem},model:{value:(_vm.deleteItemDialog),callback:function ($$v) {_vm.deleteItemDialog=$$v},expression:"deleteItemDialog"}})
}
var staticRenderFns = []

export { render, staticRenderFns }